import { api } from './index';
import redirectToHome from '../utils/redirectToHome';

export const redeemVoucher = voucher => api.get(`vouchers/${voucher}`);
export const redeemVoucherByEmail = (voucher, email) =>
  api.get(`vouchers/${voucher}`, {
    params: {
      secret: email
    }
  });
export const getPostcodes = (token, postcode) =>
  api
    .get(`vouchers/postcodes?postcode=${postcode}`, {
      headers: { Authorization: token }
    })
    .catch(error => {
      if (error.response.status === 500) {
        throw error;
      } else {
        redirectToHome;
      }
    });

export const redeemExtraVoucher = (voucher, token) =>
  api.post(
    `vouchers/${voucher}/add`,
    {},
    {
      headers: { Authorization: token }
    }
  );

export const removeExtraVoucher = (voucher, token) =>
  api.post(
    `vouchers/${voucher}/remove`,
    {},
    {
      headers: { Authorization: token }
    }
  );

export default {
  redeemVoucherByEmail,
  redeemVoucher,
  redeemExtraVoucher,
  removeExtraVoucher,
  getPostcodes
};
